(function () {

    'use strict';

    angular
        .module('app')
        .factory('BrandService', BrandService)

    function BrandService($http, $q, $rootScope, WebAPIUrl, WebApiService) {

        var service = {

            getBrands: getBrands,
            getBrandsByUser: getBrandsByUser,
            getSAPBrandId: getSAPBrandId,
            canSfOverride: canSfOverride,
            isBrandPDMReady: isBrandPDMReady
        };

        return service;

        function getBrands() {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Brand/GetBrands',
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function getBrandsByUser() {
            return WebApiService.get('/api/Brand/GetBrandsByUser');
        }

        function getSAPBrandId(brandId) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Brand/GetSAPBrandId?BrandId=' + brandId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function canSfOverride(brandId) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Brand/CanSfOverride?BrandId=' + brandId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }

        function isBrandPDMReady(brandId) {
            var deferred = $q.defer();

            $http({
                method: 'GET',
                url: WebAPIUrl + '/api/Brand/isBrandPDMReady?BrandId=' + brandId,
                ignoreLoadingBar: true
            }).success(function (data, status, headers, cfg) {
                deferred.resolve(data);
            }).error(function (err, status) {
                deferred.reject(err, status);
            });

            return deferred.promise;
        }


    }


})();
